"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkToolbarButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _toolbar = require("./toolbar");
var _useMarkToolbarButton = require("../hooks/useMarkToolbarButton");
var _jsxRuntime = require("react/jsx-runtime");
/* copied from https://v36.platejs.org/docs/components/mark-toolbar-button */

var MarkToolbarButton = exports.MarkToolbarButton = (0, _cn.withRef)(function (_ref, ref) {
  var clear = _ref.clear,
    nodeType = _ref.nodeType,
    rest = _objectWithoutProperties(_ref, ["clear", "nodeType"]);
  var state = (0, _useMarkToolbarButton.useMarkToolbarButtonState)({
    clear: clear,
    nodeType: nodeType
  });
  var _ref2 = (0, _useMarkToolbarButton.useMarkToolbarButton)(state),
    props = _ref2.props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_toolbar.ToolbarButton, _objectSpread({
    ref: ref
  }, props, rest));
});